"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExperienceTypeGroup = void 0;
// eslint-disable-next-line no-shadow
var ExperienceTypeGroup;
(function (ExperienceTypeGroup) {
    ExperienceTypeGroup["MODAL"] = "MODAL";
    ExperienceTypeGroup["FULLPAGE"] = "FULLPAGE";
})(ExperienceTypeGroup = exports.ExperienceTypeGroup || (exports.ExperienceTypeGroup = {}));
//# sourceMappingURL=ExperienceTypes.js.map